import * as THREE from 'three';
import React from 'react';
import { RoundedBox, Text } from '@react-three/drei';

const WallNameTemplate = ({ position, rotation, value, slopeAngle }) => {
    let scaleValue = 0.3;
    if (value.toLowerCase() === 'front' || value.toLowerCase() === 'left' || value.toLowerCase() === 'right' || value.toLowerCase() === 'back') scaleValue = 0.4;
    else if (value.toLowerCase().includes('lean storage')) scaleValue = 0.24

    return (
        <group rotation={rotation} position={position} >
            <group position={[0, 0.3, 1]} rotation={[-THREE.MathUtils.degToRad(slopeAngle), 0, 0]}>
                <RoundedBox args={[[...value].length * scaleValue, 0.7, 1]} radius={0.35} scale={[1, 1, 0.01]} >
                    <meshStandardMaterial color={'white'} />
                </RoundedBox>
                <Text
                    color="black"
                    anchorX="center" 
                    anchorY="middle" 
                    fontSize={0.45}
                    fontWeight={400}
                    position={[0,0,0.01]}
                >
                    <meshBasicMaterial color={"#000"} fog={false} toneMapped={false} />
                    {value}
                </Text>
            </group>
        </group>
    )
}

export default WallNameTemplate;
